/* eslint-disable import/prefer-default-export */
export const MOVING_AVERAGE_SIZE_MULTIPLIER = 0.2;
